export default __webpack_public_path__ + "ef76dfe271bef95422fd0e17b53d7b53.svg";